import React from 'react';
import './StatutoryComplianceNotice.css';

interface StatutoryComplianceNoticeProps {
  variant?: 'checkout' | 'order-received' | 'cart';
  storeName?: string;
  phone?: string;
  whatsappNumber?: string;
  className?: string;
  showButtons?: boolean;
}

export default function StatutoryComplianceNotice({
  variant = 'checkout',
  storeName = 'Jai Bhavani Fireworks',
  phone = '+91-7990696364',
  whatsappNumber = '917990696364',
  className = '',
  showButtons = true,
}: StatutoryComplianceNoticeProps) {
  const cleanPhone = phone.replace(/[^0-9+]/g, '');

  if (variant === 'order-received') {
    return (
      <div className={`statutory-notice-box variant-order-received ${className}`}>
        <div className="statutory-notice-header">
          <svg className="statutory-notice-icon icon-blue" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
          </svg>
          <h4 className="statutory-notice-title">
            Website is only offline Booking and Display purpose ({storeName}). Call or WhatsApp us{' '}
            <span className="statutory-phone-highlight">{phone}</span> for any help. Thank you booking purposes only.
          </h4>
        </div>

        <p className="statutory-notice-body">
          As per 2018 supreme court order, online sale of firecrackers are not permitted! We value our customers and at
          the same time, respect jurisdiction. We request you to add your products to the cart and submit the required
          crackers through the enquiry button. We will contact you within 24 hrs and confirm the order through WhatsApp or
          phone call. Please add and submit your enquiries and enjoy your Diwali with {storeName}.
        </p>

        <p className="statutory-notice-body">
          {storeName} as a company follows 100% legal &amp; statutory compliances and all our shops and go-downs are
          maintained strictly as per the Explosives Act.
        </p>

        {showButtons && (
          <div className="statutory-notice-actions">
            <a href={`tel:${cleanPhone}`} className="statutory-btn-call">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.44-5.15-3.75-6.59-6.59l1.97-1.57c.28-.28.36-.67.25-1.02A11.36 11.36 0 018.57 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.66c.12.8.31 1.57.57 2.31L6.07 8.5C5.61 7.4 5.25 6.23 5.03 5zM19 18.97c-1.23-.22-2.4-.58-3.5-1.04l1.19-1.19c.74.26 1.51.45 2.31.57v1.66z" />
              </svg>
              <span>Call us</span>
            </a>
            <a
              href={`https://wa.me/${whatsappNumber}?text=Hello%20${encodeURIComponent(
                storeName
              )},%20I%20have%20an%20order%20enquiry.`}
              target="_blank"
              rel="noopener noreferrer"
              className="statutory-btn-wa"
            >
              <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0012.04 2zm.02 18.17c-1.5 0-2.98-.4-4.27-1.17l-.31-.18-3.17.83.85-3.09-.2-.32a8.033 8.033 0 01-1.23-4.33c0-4.48 3.65-8.13 8.13-8.13 2.17 0 4.21.85 5.75 2.38a8.077 8.077 0 012.38 5.75c0 4.49-3.65 8.13-8.13 8.13z" />
              </svg>
              <span>WhatsApp us</span>
            </a>
          </div>
        )}
      </div>
    );
  }

  if (variant === 'cart') {
    return (
      <div className={`statutory-notice-box variant-cart ${className}`}>
        <div className="statutory-notice-header">
          <svg className="statutory-notice-icon icon-amber" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
          </svg>
          <h4 className="statutory-notice-title">
            Website is only offline Booking and Display purpose ({storeName}). Call or WhatsApp us{' '}
            <span className="statutory-phone-highlight">{phone}</span> for any help.
          </h4>
        </div>

        <p className="statutory-notice-body">
          As per 2018 supreme court order, online sale of firecrackers are not permitted! We value our customers and at
          the same time, respect jurisdiction. We request you to add your products to the cart and submit the required
          crackers through the enquiry button. We will contact you within 2-3 hrs and confirm the order through WhatsApp or
          phone call.
        </p>

        {showButtons && (
          <div className="statutory-notice-actions">
            <a href={`tel:${cleanPhone}`} className="statutory-btn-call">
              <span>Call us</span>
            </a>
            <a
              href={`https://wa.me/${whatsappNumber}?text=Hello%20${encodeURIComponent(
                storeName
              )},%20I%20need%20assistance%20with%20my%20cart.`}
              target="_blank"
              rel="noopener noreferrer"
              className="statutory-btn-wa"
            >
              <span>WhatsApp us</span>
            </a>
          </div>
        )}
      </div>
    );
  }

  // Default: 'checkout' variant matching Image 1
  return (
    <div className={`statutory-notice-box ${className}`}>
      <div className="statutory-notice-header">
        <svg className="statutory-notice-icon icon-red" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
        </svg>
        <h4 className="statutory-notice-title">
          Website is only offline Booking and Display purpose ({storeName}). Call or WhatsApp us{' '}
          <span className="statutory-phone-highlight">{phone}</span> for any help.
        </h4>
      </div>

      <p className="statutory-notice-body">
        As per 2018 supreme court order, online sale of firecrackers are not permitted! We value our customers and at
        the same time, respect jurisdiction. We request you to add your products to the cart and submit the required
        crackers through the enquiry button. We will contact you within 2-3 hrs and confirm the order through WhatsApp or
        phone call. Please add and submit your enquiries and enjoy your Diwali with {storeName}.
      </p>

      <p className="statutory-notice-body">
        {storeName} as a company following 100% legal &amp; statutory compliances and all our shops, go-downs are
        maintained as per the explosive acts.
      </p>

      {showButtons && (
        <div className="statutory-notice-actions">
          <a href={`tel:${cleanPhone}`} className="statutory-btn-call">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.44-5.15-3.75-6.59-6.59l1.97-1.57c.28-.28.36-.67.25-1.02A11.36 11.36 0 018.57 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.66c.12.8.31 1.57.57 2.31L6.07 8.5C5.61 7.4 5.25 6.23 5.03 5zM19 18.97c-1.23-.22-2.4-.58-3.5-1.04l1.19-1.19c.74.26 1.51.45 2.31.57v1.66z" />
            </svg>
            <span>Call us</span>
          </a>
          <a
            href={`https://wa.me/${whatsappNumber}?text=Hello%20${encodeURIComponent(
              storeName
            )},%20I%20have%20an%20order%20inquiry.`}
            target="_blank"
            rel="noopener noreferrer"
            className="statutory-btn-wa"
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0012.04 2zm.02 18.17c-1.5 0-2.98-.4-4.27-1.17l-.31-.18-3.17.83.85-3.09-.2-.32a8.033 8.033 0 01-1.23-4.33c0-4.48 3.65-8.13 8.13-8.13 2.17 0 4.21.85 5.75 2.38a8.077 8.077 0 012.38 5.75c0 4.49-3.65 8.13-8.13 8.13z" />
            </svg>
            <span>WhatsApp us</span>
          </a>
        </div>
      )}
    </div>
  );
}
